// extracted by mini-css-extract-plugin
export default {"Fields":"FieldDataC_Fields__5tdT5"};